const getVendaExternaItensFilterFields = () => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'descricao',
    label: 'Descrição',
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    initial: true,
  },
  {
    name: 'referencia',
    label: 'Referência',
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Emissão Final',
    type: 'date',
  },
  {
    name: 'quantidade',
    label: 'Quantidade',
    type: 'currency',
  },
  {
    name: 'preco',
    label: 'Preço Unitário',
    type: 'currency',
  },
  {
    name: 'kit_id',
    label: 'Código do Kit',
    type: 'number',
  },
];

export default getVendaExternaItensFilterFields;
